<template>
	<LayoutFormInputGeneral :inputId="inputId" :title="title" :subtitle="subtitle">
		<div class="input-group mb-3">
			<input type="text"
				:id="inputId"
				:value="modelValue"
				class="form-control"
				:placeholder="placeholder"
				autocomplete="off"
				readonly>
			<button type="button" class="btn btn-square btn-neutral" @click="copy"><i class="bi bi-copy"></i></button>
			<button type="button" class="btn btn-square btn-neutral" @click="share"><i class="bi bi-share"></i></button>
		</div>
	</LayoutFormInputGeneral>
</template>

<script>
	import { useToast } from 'vue-toastification';

	export default {
		props: {
			modelValue: String,
			title: String,
			subtitle: String,
			placeholder: String,
			share: Object
		},
		setup(props, { emit }) {
			const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;
			const toast = useToast();

			const copy = async () => {
				try {
					await navigator.clipboard.writeText(props.modelValue);
					toast.success('¡Copiado con éxito!');
				}catch {
					toast.error('Error al copiar el contenido');
				}
			}

			const share = () => {
				if(navigator.canShare) {
					navigator.share({
						title: props.share?.title,
						text: props.share?.text,
						url: props.modelValue
					}).then(() => {
						toast.success('Contenido compartido exitosamente');
					}).catch((error) => {
						toast.error('Error al compartir el contenido');
					});
				}else{
					toast.error(`Tu dispositivo no permite compartir contenido`);
				}
			}

			return { inputId, copy, share };
		}
	}
</script>